export const changeOfEnergisationSchema = {
  title: 'Change of Energisation',
  type: 'object',
  properties: {
    mpan_core: {
      type: 'string',
      title: 'MPAN Core',
    },
    requested_energisation_status: {
      type: 'string',
      title: 'Requested Energisation Status',
      enum: ['E', 'D'],
      enumNames: ['Energised', 'De-energised'],
    },
  },
  required: ['mpan_core', 'requested_energisation_status'],
};

export const changeOfEnergisationUISchema = {
  mpan_core: {
    'ui:placeholder': 'Select MPAN',
  },
  requested_energisation_status: {
    'ui:placeholder': 'Select Energisation Status',
  },
};
